import dados from '@/dados/dados.js';


export default {
    name: 'macesso',
    data() {
        return{
            retorno:[],
            respostaJSON: []
        }
    },
    async recuperarCaminho(){

        await dados.ler("Acesso/RecuperarCaminho", {modulo: "finlev"}).then(r => {
            
            let resposta = JSON.parse(r.data);
            var retorno = resposta[0];
            var caminho = retorno.caminho;
            if (retorno.versao != undefined && retorno.versao != "") {
                caminho += "/" + retorno.versao;
            }
            caminho += "/" + retorno.paginainicial
            this.retorno = caminho;
            console.log(caminho);

        })
        .catch(error=>{
            console.log(error.response)
            throw error;
        })

    },

}